export class EditLevisOrderAcceptanceRequest {
    id:number;
    poNumber: string;
     material: string;
    itemNo: string;
    buyer: string;
    //  deliveryDate:string;
      poLine:string
      coNumber:string
      coDate:string
    
}